@for (table of tableReportData$ | async; track table) {
  <div class="avoid-page-break">
    <mat-table
      class="table-wrapper"
      [dataSource]="table.nutrientBalanceItems"
      data-test="nutrient-balance-table"
    >
      <ng-container matColumnDef="name">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-4 flex text--bold header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--bold">
              <ng-container>{{
                table.translateName ? (table.name | translate) : table.name
              }}</ng-container>
            </span>
          </div>
        </mat-header-cell>
      </ng-container>
      <ng-container matColumnDef="hectares">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-4 flex text--bold flex--justify-flex-end header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--right text--bold">
              <ng-container>{{ table.totalHectares | number: '1.0-2' }} ha</ng-container>
            </span>
          </div>
        </mat-header-cell>
      </ng-container>
      <ng-container matColumnDef="element">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--bold">
              <ng-container>{{ 'element' | translate }}</ng-container>
            </span>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex__child flex__child-2">
          <span>{{ element.source | translate }} </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="supply">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--bold">
              <ng-container
                >{{ 'supply' | translate }} ({{ 'kgAsHa' | translate | lowercase }})</ng-container
              >
            </span>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex__child flex__child-2">
          <div>
            {{ element.data.supply | number: '1.0-0' }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="drainage">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--bold">
              <ng-container>
                {{ 'drainage' | translate }} ({{ 'kgAsHa' | translate | lowercase }})</ng-container
              >
            </span>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex__child flex__child-2">
          <div>
            {{ element.data.drainage | number: '1.0-0' }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="balance">
        <mat-header-cell
          *matHeaderCellDef
          class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
        >
          <div class="text--right spacing--margin-right">
            <span class="text--bold">
              <ng-container
                >{{ 'balance' | translate }} ({{ 'kgAsHa' | translate | lowercase }})</ng-container
              >
            </span>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex__child flex__child-2">
          <div>
            {{ element.data.balance | number: '1.0-0' }}
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="['name', 'hectares']"
        data-test="nutrient-balance-table__header_first"
        class="has-hover-hightlighting"
      ></mat-header-row>
      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        data-test="nutrient-balance-table__header_second"
        class="has-hover-hightlighting"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="has-hover-hightlighting"
      ></mat-row>
    </mat-table>
    <br /><br />
  </div>
}
